import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import RingLoader from "react-spinners/RingLoader";
import { css } from "@emotion/react";
import { postRequest } from "../../../Globals/GlobalFunctions/Axiosfunctions";
import { ConfirmationSectionRow } from "./ConfirmationSectionRow";
import { useCookies } from "react-cookie";

const override = css`
  display: block;
  margin: auto;
  border-color: red;
`;

export default function MultipleConfirmationSection(props) {
  let [ShowLoader, setShowLoader] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  let [guests, setGuests] = useState([]);
  const [cookies, setCookie] = useCookies(["confirmation"]);

  const searchParams = new URLSearchParams(document.location.search);

  useEffect(() => {
    if (cookies.confirmation) {
      let guests = [];
      const cookieGuests = JSON.parse(atob(cookies.confirmation));
      if (searchParams.get("guests")) {
        guests = getGuestsArray();
      }
      const allExist = guests.every((guest1) =>
        cookieGuests.some((guest2) => guest1.name === guest2.name)
      );
      if (guests.length > 0 && !allExist) {
        setGuests(guests);
      } else if (allExist) {
        guests.forEach((guest) => {
          cookieGuests.forEach((cG) => {
            if (cG.name === guest.name) {
              guest.isComing = cG.isComing;
            }
          });
        });
        setGuests(guests);
        setConfirmed(true);
      }
    } else if (searchParams.get("guests")) {
      setGuests(getGuestsArray());
    }

    return () => {};
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    let submit = true;
    guests.forEach((guest) => {
      if (guest.isComing === null) {
        submit = false;
        return;
      }
    });
    if (submit) {
      const stringifiedGuests = JSON.stringify(guests);
      console.log(stringifiedGuests);
      let params = {
        names: stringifiedGuests,
        attending: data.attending === "true",
        event_id: props.eventId,
      };
      setShowLoader(true);
      const save = await postRequest("guests", params);

      if (save.hasError) {
        setShowLoader(false);
        alert("Sorry We Couldn't Confirm please Try Again Later!");
      } else {
        setShowLoader(false);

        alert("Thank You For Your Confirmation!");
        // else  alert('We are sorry you will not join us')
        reset({
          names: null,
          attending: "",
        });
        setGuestsCookie();
        setConfirmed(true);
      }
    } else {
      alert("Please confirm for all guests!");
    }
  };

  const getGuestsArray = () => {
    const suggestedGuests = searchParams.get("guests").split(",");
    const mappedGuests = suggestedGuests.map((guest) => ({
      name: guest,
      isComing: null,
    }));
    return [...mappedGuests];
  };

  const setGuestsCookie = () => {
    let exGuests = [];
    if (cookies.confirmation) {
      exGuests = JSON.parse(atob(cookies.confirmation));
    }
    console.log(...guests);
    exGuests.push(...guests);

    setCookie("confirmation", btoa(JSON.stringify(exGuests)));
  };

  const changeIsComing = (name, coming) => {
    const copiedGuests = [...guests];

    copiedGuests.forEach((guest) => {
      if (guest.name === name) {
        guest.isComing = coming;
      }
    });
    setGuests([...copiedGuests]);
  };

  return (
    <div className="traditionalSection textBlack">
      {ShowLoader ? (
        <div className="Loader">
          <div className="LoaderCont">
            <RingLoader
              css={override}
              size={45}
              color={"#fff"}
              loading={true}
            />
          </div>
        </div>
      ) : null}
      {/* <div className="font18 mt20 times ">{props.slide.attribute_1}</div> */}
      <p className={props.className}>{props.content}</p>
      <form onSubmit={handleSubmit(onSubmit)} className="attendanceForm">
        {guests.map((guest, index) => (
          <div key={index}>
            <ConfirmationSectionRow
              name={guest.name}
              changeIsComing={changeIsComing}
              isComing={guest.isComing}
            />
          </div>
        ))}
        {!confirmed && (
          <button
            type="submit"
            className="submitBtn mt25 textWhite"
            disabled={ShowLoader}
          >
            RSVP
          </button>
        )}
      </form>

      {/* <div className='font16 LatoRegular wordSpacing mt25'>For those who wish a wedding list <br/>
			 will be available at any WHISH Money branch. <br/>
			 Account number: 20471853
			 </div> */}
    </div>
  );
}
